import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import {
  Button,
  Container,
  SuccessMessage,
} from '../../common/form';

import { propTypes, defaultProps } from '../prop-types';
import useAdvertisingStore from './state-hook';
import {
  createAdvertising,
  updateAdvertising,
} from '../../../../services/lwadmin/advertising/advertising-service';

import withNameFileUpload from '../../common/file-upload';
import withNameInput from '../../common/input';
import withNameDatepicker from '../../common/datepicker';

const Name = withNameInput('advertising', 'name', useAdvertisingStore);
const Image = withNameFileUpload('advertising', 'image', useAdvertisingStore, 'image/gif, image/png, image/jpeg', 'Image');
const Link = withNameInput('advertising', 'link', useAdvertisingStore);
const StartDate = withNameDatepicker('advertising', 'startDate', useAdvertisingStore, 'Start Date');
const FinishDate = withNameDatepicker('advertising', 'finishDate', useAdvertisingStore, 'Finish Date');

const SContainer = styled(Container)`
  padding-bottom: 40px;
`;

export default function Form(props) {
  const [saving, setSaving] = React.useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);

  const set = useAdvertisingStore(state => state.set);
  const advertising = useAdvertisingStore(state => state.advertising);

  const { id } = advertising;

  useChangeAwareEffect(({ isMount }) => {
    isMount && set(state => {
      state.advertising = (props || defaultProps).advertising;
    });
  }, {});

  const saveAdvertising = e => {
    e && e.preventDefault();

    setSaving(true);

    const payload = {
      name: advertising.name,
      image: advertising.image,
      link: advertising.link,
      start_date: advertising.startDate,
      finish_date: advertising.finishDate,
    };

    const createOrUpdate = id
      ? updateAdvertising(id, payload)
      : createAdvertising(payload);

    createOrUpdate.then(resp => {
      setSaving(false);
      setShowSuccessMessage(true);

      const createdId = _.get(resp, 'data.id');
      if (createdId) {
        set(state => {
          state.advertising.id = createdId;
        });
      }

      set(state => {
        state.errors = {};
      });
    }).catch(error => {
      setSaving(false);
      setShowSuccessMessage(false);

      set(state => {
        state.errors = _.get(error, 'response.data', {});
      });

      setSaving(false);
    });
  };

  return (
    <SContainer>
      {showSuccessMessage && (
        <SuccessMessage>
          Advertising successfully saved
        </SuccessMessage>
      )}
      <Name />
      <Image />
      <Link />
      <StartDate />
      <FinishDate />
      <Button className="btn btn-primary" onClick={saveAdvertising} disabled={saving}>
        {saving ? 'Saving' : 'Save'}
      </Button>
    </SContainer>
  );
}

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;
